// 1.This map is only for inverter 

// import React, { useEffect, useState, useContext } from 'react';
// import {
//   MapContainer,
//   TileLayer,
//   Marker,
//   Popup,
//   Tooltip,
//   useMap
// } from 'react-leaflet';
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';
// import 'leaflet.fullscreen/Control.FullScreen.css';
// import 'leaflet.fullscreen/Control.FullScreen';

// import { AppThemeContext } from '../../../../context/AppThemeContext';
// import { AuthenticationContext } from '../../../../context/AuthenticationContext';
// import { APP_KEY } from "../../../../api/AxiosApi";
// import { Link } from 'react-router-dom';
// import { BusinessApi, InverterDetail } from '../../../../api/Api';
// import TopHeader from '../../../../components/general/TopHeader';


// // Custom marker icons
// const redIcon = new L.Icon({
//   iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
//   shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
//   iconSize: [25, 41],
//   iconAnchor: [12, 41],
//   popupAnchor: [1, -34],
//   shadowSize: [41, 41]
// });

// const greenIcon = new L.Icon({
//   iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png',
//   shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
//   iconSize: [25, 41],
//   iconAnchor: [12, 41],
//   popupAnchor: [1, -34],
//   shadowSize: [41, 41]
// });

// export default function Dashboard7Location() {
//   const { PrimaryColor } = useContext(AppThemeContext);
//   const { userLogin } = useContext(AuthenticationContext);
//   const [logData, setLogData] = useState([]);


//   const [credentials] = useState({
//     LOGIN_ID: sessionStorage.getItem("LoginID") || "",
//     LOC_CODE: sessionStorage.getItem("LCODE") || "",
//     PASS_KEY: sessionStorage.getItem("PASS_KEY") || "xyz",
//     WEB_KEY: sessionStorage.getItem("WEB_KEY") || "WEBXYZ321",
//   });

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await InverterDetail(credentials);
//         if (res?.data && Array.isArray(res.data)) {
//           setLogData(res.data);
//         }
//       } catch (err) {
//         console.error("Error fetching data:", err);
//       }
//     };
//     fetchData();
//   }, [credentials.LOGIN_ID]);



//   // console.log("logdataMap", logData)

//   return (

//     <>

//     <TopHeader/>
//     <div style={{ height: "78vh",marginTop:"1rem" }}>
//       <MapContainer
//         center={[27.0, 80.0]}
//         zoom={5}
//         scrollWheelZoom={false}
//         style={{ height: "100%", width: "98%" }}
//         id="map"
//       >
//         <TileLayer
//           attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
//           url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//         />






//         {logData
//           .filter((data) => data.Latitude && data.Longitude)
//           .map((location, index) => {
//             const markerIcon = location.STS?.toLowerCase() === 'online' ? greenIcon : redIcon;
//             return (
//               <Marker
//                 key={index}
//                 position={[parseFloat(location.Latitude), parseFloat(location.Longitude)]}
//                 icon={markerIcon}
//               >
//                 <Tooltip direction="top" offset={[0, -20]} opacity={1}>
//                   <div className="tooltip-class">
//                   <strong><h6 className='text-primary'>
//                     {location.NAME}
//                   </h6></strong>
//                   <p><strong>Status:</strong> {location.STS}</p>
//                     <p><strong>Address:</strong> {location.USR}</p>


//                     <p><strong>Make:</strong> {location.MAKE}</p>
//                     <p><strong>Capacity (kWP):</strong> {location.KWP}</p>

//                     <p><strong>	Day kWh:</strong> {location.DAY_KWH} &nbsp;({location.E_DATE})</p>
//                     <p><strong>Total kWh:</strong> {location.TOT_GEN}</p>
//                     <p><strong>Instant KW:</strong> {location.KW}</p>
//                   </div>
//                 </Tooltip>
//                 <Popup>
//                   <strong><h6 className='text-primary'>
//                     {location.NAME}
//                   </h6></strong>
//                   <p><strong>Status:</strong> {location.STS}</p>
//                   <p><strong>Address:</strong> {location.USR}</p>


//                     <p><strong>Make:</strong> {location.MAKE}</p>
//                     <p><strong>Capacity (kWP):</strong> {location.KWP}</p>

//                     <p><strong>	Day kWh:</strong> {location.DAY_KWH} &nbsp;({location.E_DATE})</p>
//                     <p><strong>Total kWh:</strong> {location.TOT_GEN}</p>
//                     <p><strong>Instant KW:</strong> {location.KW}</p>
//                 </Popup>
//               </Marker>
//             );
//           })}



//       </MapContainer>
//     </div>
//     </>

//   );
// }


// 2.This map is  for inverter and userlogin

// import React, { useEffect, useState, useContext } from 'react';
// import {
//   MapContainer,
//   TileLayer,
//   Marker,
//   Popup,
//   Tooltip
// } from 'react-leaflet';
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';
// import 'leaflet.fullscreen/Control.FullScreen.css';
// import 'leaflet.fullscreen/Control.FullScreen';

// import { AppThemeContext } from '../../../../context/AppThemeContext';
// import { AuthenticationContext } from '../../../../context/AuthenticationContext';
// import { InverterDetail } from '../../../../api/Api';
// import TopHeader from '../../../../components/general/TopHeader';

// // Custom marker icons
// const redIcon = new L.Icon({
//   className:"blink",
//   iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
//   shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
//   iconSize: [25, 41],
//   iconAnchor: [12, 41],
//   popupAnchor: [1, -34],
//   shadowSize: [41, 41]
// });

// const greenIcon = new L.Icon({
//   className:"blink",
//   iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png',
//   shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
//   iconSize: [25, 41],
//   iconAnchor: [12, 41],
//   popupAnchor: [1, -34],
//   shadowSize: [41, 41]
// });

// // Blue marker for the logged-in user
// const userIcon = new L.Icon({
//   className:"blink",
//   iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png',
//   shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
//   iconSize: [25, 41],
//   iconAnchor: [12, 41],
//   popupAnchor: [1, -34],
//   shadowSize: [41, 41]
// });



// export default function Dashboard7Location() {
//   const { LoggedInUserInfo } = useContext(AuthenticationContext);
//   const { PrimaryColor } = useContext(AppThemeContext);
//   const [logData, setLogData] = useState([]);

//   const [credentials] = useState({
//     LOGIN_ID: sessionStorage.getItem("LoginID") || "",
//     LOC_CODE: sessionStorage.getItem("LCODE") || "",
//     PASS_KEY: sessionStorage.getItem("PASS_KEY") || "xyz",
//     WEB_KEY: sessionStorage.getItem("WEB_KEY") || "WEBXYZ321",
//   });

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await InverterDetail(credentials);
//         if (res?.data && Array.isArray(res.data)) {
//           setLogData(res.data);
//         }
//       } catch (err) {
//         // console.error("Error fetching data:", err);
//       }
//     };
//     fetchData();
//   }, [credentials.LOGIN_ID]);

//   return (
//     <>
//       <TopHeader />
//       <div style={{ height: "78vh", marginTop: "1rem" }}>
//         <MapContainer
//           center={[27.0, 80.0]}
//           zoom={5}
//           scrollWheelZoom={false}
//           style={{ height: "100%", width: "98%",border:"2px solid black" }}
//           id="map"
//         >
//           {/* <TileLayer
//             attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
//             url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//           /> */}
//           <TileLayer
//             url="https://api.maptiler.com/maps/basic-v2/256/{z}/{x}/{y}.png?key=wqBRkwqr9CEgeNgas9mP"
//             attribution='&copy; <a href="https://www.maptiler.com/copyright/">MapTiler</a> & <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//           />


//           {LoggedInUserInfo?.LATITUDE && LoggedInUserInfo?.LONGITUDE && (
//             <Marker
//               position={[parseFloat(LoggedInUserInfo.LATITUDE), parseFloat(LoggedInUserInfo.LONGITUDE)]}
//               icon={userIcon}
//               zIndexOffset={1000}
//             >
//               <Tooltip direction="top" offset={[0, -20]} opacity={1}>
//                 <div className="tooltip-class">
//                   <strong><h6 className='text-primary'>{LoggedInUserInfo?.username}</h6></strong>
//                   <p><strong>Address:</strong> {LoggedInUserInfo?.Address}</p>
//                   <p><strong>Capacity (kWP):</strong> {LoggedInUserInfo?.PLANT_CAPACITY}</p>
//                 </div>
//               </Tooltip>
//               <Popup>
//                 <strong><h6 className='text-primary'>{LoggedInUserInfo?.username}</h6></strong>
//                 <p><strong>Address:</strong> {LoggedInUserInfo?.Address}</p>
//                 <p><strong>Capacity (kWP):</strong> {LoggedInUserInfo?.PLANT_CAPACITY}</p>
//               </Popup>
//             </Marker>
//           )}


//           {logData
//             .filter((data) => data.Latitude && data.Longitude)
//             .map((location, index) => {
//               const markerIcon = location.STS?.toLowerCase() === 'online' ? greenIcon : redIcon;
//               return (
//                 <Marker
//                   key={index}
//                   position={[parseFloat(location.Latitude), parseFloat(location.Longitude)]}
//                   icon={markerIcon}
//                 >
//                   <Tooltip direction="top" offset={[0, -20]} opacity={1}>
//                     <div className="tooltip-class">
//                       <strong><h6 className='text-primary'>{location.NAME}</h6></strong>
//                       <p><strong>Status:</strong> {location.STS}</p>
//                       <p><strong>Address:</strong> {location.USR}</p>
//                       <p><strong>Make:</strong> {location.MAKE}</p>
//                       <p><strong>Capacity (kWP):</strong> {location.KWP}</p>
//                       <p><strong>Day kWh:</strong> {location.DAY_KWH} ({location.E_DATE})</p>
//                       <p><strong>Total kWh:</strong> {location.TOT_GEN}</p>
//                       <p><strong>Instant KW:</strong> {location.KW}</p>
//                     </div>
//                   </Tooltip>
//                   <Popup>
//                     <strong><h6 className='text-primary'>{location.NAME}</h6></strong>
//                     <p><strong>Status:</strong> {location.STS}</p>
//                     <p><strong>Address:</strong> {location.USR}</p>
//                     <p><strong>Make:</strong> {location.MAKE}</p>
//                     <p><strong>Capacity (kWP):</strong> {location.KWP}</p>
//                     <p><strong>Day kWh:</strong> {location.DAY_KWH} ({location.E_DATE})</p>
//                     <p><strong>Total kWh:</strong> {location.TOT_GEN}</p>
//                     <p><strong>Instant KW:</strong> {location.KW}</p>
//                   </Popup>
//                 </Marker>
//               );
//             })}
//         </MapContainer>
//       </div>
//     </>
//   );
// }


// 3.new updated ac,dc capacity

import React, { useEffect, useState, useContext } from 'react';
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Tooltip
} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.fullscreen/Control.FullScreen.css';
import 'leaflet.fullscreen/Control.FullScreen';

import { AppThemeContext } from '../../../../context/AppThemeContext';
import { AuthenticationContext } from '../../../../context/AuthenticationContext';
import { InverterDetail } from '../../../../api/Api';
import TopHeader from '../../../../components/general/TopHeader';

// Custom marker icons
const redIcon = new L.Icon({
  className: "blink",
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const greenIcon = new L.Icon({
  className: "blink",
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

// Blue marker for the logged-in user
const userIcon = new L.Icon({
  className: "blink",
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});



export default function Dashboard7Location() {
  const { LoggedInUserInfo } = useContext(AuthenticationContext);
  const { PrimaryColor } = useContext(AppThemeContext);
  const [logData, setLogData] = useState([]);

  const [credentials] = useState({
    LOGIN_ID: sessionStorage.getItem("LoginID") || "",
    LOC_CODE: sessionStorage.getItem("LCODE") || "",
    PASS_KEY: sessionStorage.getItem("PASS_KEY") || "xyz",
    WEB_KEY: sessionStorage.getItem("WEB_KEY") || "WEBXYZ321",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await InverterDetail(credentials);
        if (res?.data && Array.isArray(res.data)) {
          setLogData(res.data);
        }
      } catch (err) {
        // console.error("Error fetching data:", err);
      }
    };
    fetchData();
  }, [credentials.LOGIN_ID]);

  return (
    <>
      <TopHeader />
      <div style={{ height: "78vh", marginTop: "1rem" }}>
        <MapContainer
          center={[27.0, 80.0]}
          zoom={5}
          scrollWheelZoom={false}
          style={{ height: "100%", width: "98%", border: "2px solid black" }}
          id="map"
        >
          {/* <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          /> */}
          <TileLayer
            url="https://api.maptiler.com/maps/basic-v2/256/{z}/{x}/{y}.png?key=wqBRkwqr9CEgeNgas9mP"
            attribution='&copy; <a href="https://www.maptiler.com/copyright/">MapTiler</a> & <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />


          {LoggedInUserInfo?.LATITUDE && LoggedInUserInfo?.LONGITUDE && (
            <Marker
              position={[parseFloat(LoggedInUserInfo.LATITUDE), parseFloat(LoggedInUserInfo.LONGITUDE)]}
              icon={userIcon}
              zIndexOffset={1000}
            >
              <Tooltip
                direction="top"
                offset={[0, -20]}
                opacity={1}
              >
                <div style={{ padding: "4px 6px", borderRadius: "5px" }}>
                  <h6
                    className="text-primary"
                    style={{ margin: 0, fontSize: "14px" }}
                  >
                    {LoggedInUserInfo?.username}
                  </h6>

                  <p style={{ margin: "2px 0", fontSize: "12px" }}>
                    <strong>Address:</strong> {LoggedInUserInfo?.Address}
                  </p>

                  <p style={{ margin: "2px 0", fontSize: "12px" }}>
                    <strong>Plant AC Capacity:</strong> {LoggedInUserInfo?.PLANT_CAPACITY}
                  </p>

                  <p style={{ margin: "2px 0", fontSize: "12px" }}>
                    <strong>Plant DC Capacity:</strong> {LoggedInUserInfo?.DC_CAPACITY}
                  </p>
                </div>
              </Tooltip>

              {/* <Popup>
                <strong><h6 className='text-primary'>{LoggedInUserInfo?.username}</h6></strong>
                <p><strong>Address:</strong> {LoggedInUserInfo?.Address}</p>
               
                <p><strong>Plant AC Capacity:</strong> {LoggedInUserInfo?.PLANT_CAPACITY}</p>
                    <p><strong>Plant DC Capacity:</strong> {LoggedInUserInfo?.DC_CAPACITY}</p>
              </Popup> */}

              <Popup>
                <div style={{ padding: "0px", margin: "0" }}>
                  <strong>
                    <h6 className='text-primary' style={{ margin: 0 }}>
                      {LoggedInUserInfo?.username}
                    </h6>
                  </strong>
                  <p style={{ margin: "0px 0" }}>
                    <strong>Address:</strong> {LoggedInUserInfo?.Address}
                  </p>
                  <p style={{ margin: "0px 0" }}>
                    <strong>Plant AC Capacity:</strong> {LoggedInUserInfo?.PLANT_CAPACITY}
                  </p>
                  <p style={{ margin: "0px 0" }}>
                    <strong>Plant DC Capacity:</strong> {LoggedInUserInfo?.DC_CAPACITY}
                  </p>
                </div>
              </Popup>
            </Marker>
          )}


          {logData
            .filter((data) => data.Latitude && data.Longitude)
            .map((location, index) => {
              const markerIcon = location.STS?.toLowerCase() === 'online' ? greenIcon : redIcon;
              return (
                <Marker
                  key={index}
                  position={[parseFloat(location.Latitude), parseFloat(location.Longitude)]}
                  icon={markerIcon}
                >
                  <Tooltip direction="top" offset={[0, -20]} opacity={1}>
                    <div className="tooltip-class">
                      <strong><h6 className='text-primary'>{location.NAME}</h6></strong>
                      <p><strong>Status:</strong> {location.STS}</p>
                      <p><strong>Address:</strong> {location.USR}</p>
                      <p><strong>Make:</strong> {location.MAKE}</p>
                      <p><strong>Capacity (kWP):</strong> {location.KWP}</p>
                      <p><strong>Day kWh:</strong> {location.DAY_KWH} ({location.E_DATE})</p>
                      <p><strong>Total kWh:</strong> {location.TOT_GEN}</p>
                      <p><strong>Instant KW:</strong> {location.KW}</p>
                    </div>
                  </Tooltip>
                  <Popup>
                    <strong><h6 className='text-primary'>{location.NAME}</h6></strong>
                    <p><strong>Status:</strong> {location.STS}</p>
                    <p><strong>Address:</strong> {location.USR}</p>
                    <p><strong>Make:</strong> {location.MAKE}</p>
                    <p><strong>Capacity (kWP):</strong> {location.KWP}</p>
                    <p><strong>Day kWh:</strong> {location.DAY_KWH} ({location.E_DATE})</p>
                    <p><strong>Total kWh:</strong> {location.TOT_GEN}</p>
                    <p><strong>Instant KW:</strong> {location.KW}</p>
                  </Popup>
                </Marker>
              );
            })}
        </MapContainer>
      </div>
    </>
  );
}
